/**
 * Arr'an (389): coalesce ability steal flies into one sequential batch per route.
 */
export function coalesceArranAbilityStealFlyBatch(grants) {
  if (!grants?.length) {
    return [];
  }

  const passthrough = [];
  const grantGroups = new Map();

  grants.forEach((grant) => {
    if (grant?.source !== 'arran_389' || !grant?.key) {
      passthrough.push(grant);
      return;
    }
    const groupKey = `${grant.arranInstanceId}:${grant.fromZone}:${grant.fromIndex}:${grant.toZone}:${grant.toIndex}`;
    if (!grantGroups.has(groupKey)) {
      grantGroups.set(groupKey, []);
    }
    grantGroups.get(groupKey).push(grant);
  });

  grantGroups.forEach((group) => {
    const sorted = [...group].sort(
      (a, b) => (a.sequenceIndex ?? 0) - (b.sequenceIndex ?? 0)
    );
    if (sorted.length === 1) {
      passthrough.push(sorted[0]);
      return;
    }
    const batchAbilityNames = sorted.map((g) => String(g.abilityName));
    passthrough.push({
      ...sorted[0],
      key: `arran-389-batch:${sorted[0].arranInstanceId}:${batchAbilityNames.join('_')}:${sorted[0].sequenceIndex}`,
      batchGrants: sorted,
      batchAbilityNames,
    });
  });

  return passthrough;
}
